module.exports = __webpack_public_path__ + "h5/img/offer_2022.3eee3e45.png";